import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const LazyLoad = ({
  resourceAction,
  params,
  render,
  defaultData = null,
}) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(defaultData);

  const load = async () => {
    try {
      setLoading(true);
      const response = await resourceAction(...params);
      setData(response);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [resourceAction, params, render]);

  return render(loading, data);
};

LazyLoad.propTypes = {
  resourceAction: PropTypes.func.isRequired,
  params: PropTypes.arrayOf(PropTypes.any), // eslint-disable-line react/forbid-prop-types
  render: PropTypes.func.isRequired,
  defaultData: PropTypes.any, // eslint-disable-line react/forbid-prop-types
};

LazyLoad.defaultProps = {
  params: [],
  defaultData: null,
};

export default LazyLoad;
